/* eslint-disable react/no-multi-comp */
import React from "react"

import { css } from "@jsUtils"

import Styles from "./contentgrid.module.scss"

/**
 * Wrap a content item with a given class as part of a ContentGrid + ContentRow
 * @param {object} props react props
 * @param {object|array} props.children child components
 * @param {string} props.gridArea class name for the component grid item (grid area)
 * @param {string} props.extraClass extra class name to wrap the item
 */
const ContentItem = ({ children, gridArea, extraClass }) => {
  return <div className={css(Styles[`${gridArea}`], extraClass)}>{children}</div>
}

export default ContentItem
